import utils from '../../../../../components/Organisms/Form/utils'
import t from '../../../../../translations/main'

const config = utils.injectTranslation({
  id: 'SourceOfFundsForm',
  path: 'onboarding.forms.CorporateAccount.SourceOfFundsForm.inputs',
  content: [
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'input',
          props: {
            name: 'sourceOfFunds',
            isTextarea: true,
            removeLabelEllipsis: true,
            required: true,
            textAreaHeight: '50px',
            textAreaPointerEvents: 'auto',
            maxlength: 1000,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'isFundsFromUBOs',
            dataList: [
              {
                id: 'companySourceOfFunds1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'companySourceOfFunds2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        marginLeft: '4%',
        width: '96%'
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'uboSourceOfWealth',
            isTextarea: true,
            removeLabelEllipsis: true,
            required: true,
            textAreaHeight: '50px',
            textAreaPointerEvents: 'auto',
            maxlength: 1000,
          },
        },
      ],
    },
  ],
})

export default config
